<div class="container">
    <div class="config-tab-title-area">
        <smart-icon class="light" name='config-data-source'></smart-icon>
        <span class="h3-regular config-tab-title">{{'dashboard.configure_your_data_source' | stringLiterals}}</span>
    </div>
    <div class="add-button">
        <button class="btn btn-primary" tam-button [tamType]="'primary'"
            (click)="addColumn($event)">{{'dashboard.add_column' | stringLiterals}}</button>
        <div #anchor class="hide-div"></div>
    </div>
    <kendo-popup [anchor]="anchor" [style.display]="(showAddPopup1||showAddPopup2)?'':'none'">
        <div *ngIf="showAddPopup1" class="add-list-container">
            <div class="add-list">
                <div class="add-list-item" (click)="addNoteColumn($event)">{{'dashboard.add_note_column' |
                    stringLiterals}}</div>
                <div class="add-list-item" (click)="addEntityColumn($event)">{{'dashboard.add_entity_column' |
                    stringLiterals}}</div>
                <div class="add-list-item" (click)="addContactColumn($event)">{{'dashboard.add_contact_column' |
                    stringLiterals}}</div>
                <div class="add-list-item" (click)="addFormulaColumn($event)">{{'dashboard.add_formula_column' |
                    stringLiterals}}</div>
                <div class="add-list-item" (click)="addRelationshipColumn($event)">{{'dashboard.add_relationship_column'
                    | stringLiterals}}</div>
                <div class="add-list-item" (click)="addMDLColumn($event)">{{'dashboard.add_mdl_column' |
                    stringLiterals}}</div>
            </div>
        </div>
        <div [style.display]="showAddPopup2?'':'none'" style="width:320px;" class="add-list-container"
            (keydown)="onAddListKeydown($event)">
            <div class="add-search">
                <input #keywordForAddInput type="text" [(ngModel)]="keywordForAdd" (keyup)="onSearchAddKeyup($event)"
                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
                    (click)="emptyClick($event)" />
            </div>
            <div #addListContainer class="add-list">
                <div *ngFor="let item of addSearchResult;index as i;trackBy:trackByFn">
                    <div class="add-list-item" [ngClass]="{'active':selectedColumnIndexForAdd===i}"
                        (click)="onAddColumnClick($event,item)">{{item.name}}</div>
                </div>
                <div class="add-list-no-item"
                    *ngIf="keywordForAdd && (!addSearchResult || addSearchResult.length === 0)">
                    {{'dashboard.no_results_found' | stringLiterals}}
                </div>
            </div>
        </div>
    </kendo-popup>
    <div class="search">
        <input type="text" placeholder="Search fields" class="searchInput" [(ngModel)]="keywordForColumn"
            (keyup)="onSearchColumnKeyup($event)" autocomplete="off" autocorrect="off" autocapitalize="off"
            spellcheck="false" />
    </div>
    <div class="column-box-panel">
        <tam-column-panel [data]="config.columns" *ngIf="!keywordForColumn">
            <ng-template #bar let-dataItem="dataItem" let-index="index">
                <div class="bar" [class.selected]="selectedColumn&&selectedColumn.guid===dataItem.guid"
                    (click)="onColumnClick(dataItem)" (contextmenu)="onContextMenu($event,dataItem,index)"
                    (touchstart)="touchstart()" (touchend)="touchend($event,dataItem,index)">
                    <div class="bar-left">
                        <smart-icon name="column-picker-drag"></smart-icon>
                        <span class="sub-title">{{dataItem.title}}</span>
                    </div>
                    <div class="bar-right">
                        <smart-icon *ngIf="dataItem.hidden" name="hidden"></smart-icon>
                        <smart-icon *ngIf="dataItem.groupId" name="cycle" [style.color]="getColor(dataItem)"
                            (click)="onColumnGroupClick($event,dataItem)"></smart-icon>
                    </div>
                </div>
                <div *ngIf="selectedColumn&&selectedColumn.guid===dataItem.guid&&!selectedColumnGroup">
                    <tam-tile-column [config]="dataItem" [wholeConfig]="config" [briefConfig]="briefConfig">
                    </tam-tile-column>
                </div>
                <div
                    *ngIf="selectedColumnGroup&&selectedColumnGroup.id===dataItem.groupId&&selectedColumnForGroup.guid===dataItem.guid">
                    <tile-column-group [config]="selectedColumnGroup" [briefConfig]="briefConfig"></tile-column-group>
                </div>
            </ng-template>
        </tam-column-panel>
        <div *ngIf="keywordForColumn">
            <div *ngFor="let dataItem of columnSearchResult;let index= index;trackBy:trackByFn">
                <div class="bar" [class.selected]="selectedColumn&&selectedColumn.guid===dataItem.guid"
                    (click)="onColumnClick(dataItem)" (contextmenu)="onContextMenu2($event,dataItem,index)"
                    (touchstart)="touchstart()" (touchend)="touchend2($event,dataItem,index)">
                    <div class="bar-left">
                        <smart-icon name="column-picker-drag"></smart-icon>
                        <span class="sub-title">{{dataItem.title}}</span>
                    </div>
                    <div class="bar-right">
                        <smart-icon *ngIf="dataItem.groupId" name="radiobutton-o" [style.color]="getColor(dataItem)"
                            (click)="onColumnGroupClick($event,dataItem)"></smart-icon>
                    </div>
                </div>
                <div *ngIf="selectedColumn&&selectedColumn.guid===dataItem.guid&&!selectedColumnGroup">
                    <tam-tile-column [config]="dataItem" [wholeConfig]="config"></tam-tile-column>
                </div>
                <div
                    *ngIf="selectedColumnGroup&&selectedColumnGroup.id===dataItem.groupId&&selectedColumnForGroup.guid===dataItem.guid">
                    <tile-column-group [config]="selectedColumnGroup"></tile-column-group>
                </div>
            </div>
        </div>
        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
    </div>
    <div class="options">
        <div class="option">
            <label tam-checkbox [value]="config.options.showRowForEveryEntity"
                (checkedChange)="onChangeShowEveryEntity($event)">
                {{'dashboard.show_row_of_every_entity_in_focus' | stringLiterals}}
            </label>
        </div>
        <div class="option">
            <label tam-checkbox [(ngModel)]="config.options.showRowAsThread" [disabled]="!canShowThreadSameRow">
                {{'dashboard.show_all_notes_of_a_thread_in_same_row' | stringLiterals}}
            </label>
        </div>
    </div>
</div>